import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Dashboard from '../Pages/Dashboard/Dashboard'
import NavBar from '../Components/NavBar'
import { Box, Typography, Link } from '@mui/material'
import CreateNewJob from '../Pages/Jobs/CreateNewJob'
import Jobs from '../Pages/Jobs/Jobs'
import SearchCandidate from '../Pages/SearchCandidate/SearchCandidate'
import SearchResults from '../Pages/SearchResults/SearchResults'
import ProfileSecurity from '../Pages/ProfileSettings/ProfileSecurity'
import GetInterviews from '../Pages/Interviews/GetInterviews'
import Candidates from '../Pages/Candidates/Candidates'

const PageRoutes = () => {
    return (
        <>
            <NavBar />

            {/* Main Content — full width, below top nav */}
            <Box component="main" sx={{
                marginTop: '60px',
                minHeight: 'calc(100vh - 60px)',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#F8F9FA',
            }}>
                {/* Page Content */}
                <Box sx={{ flexGrow: 1 }}>
                    <Routes>
                        <Route path='/dashboard' element={<Dashboard />} />
                        <Route path="/create-new-job" element={<CreateNewJob />} />
                        <Route path="/jobs" element={<Jobs />} />
                        <Route path="/search-candidate" element={<SearchCandidate />} />
                        <Route path="/search-results" element={<SearchResults />} />
                        <Route path="/profile-settings" element={<ProfileSecurity />} />
                        <Route path="/interviews" element={<GetInterviews />} />
                        <Route path="/candidates" element={<Candidates />} />
                    </Routes>
                </Box>

                {/* Footer — minimal */}
                <Box 
                    component="footer" 
                    sx={{ 
                        py: 3,
                        px: 3,
                        display: 'flex', 
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'center',
                        alignItems: 'center', 
                        gap: { xs: 1, sm: 3 },
                        borderTop: '1px solid #E5E7EB',
                        backgroundColor: '#FFFFFF',
                    }}
                >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 2.5 }}>
                        <Link href="#" sx={{ color: '#6B7280', textDecoration: 'none', fontSize: '0.8125rem', fontWeight: 400, '&:hover': { color: '#6B31C4' } }}>
                            About
                        </Link>
                        <Link href="#" sx={{ color: '#6B7280', textDecoration: 'none', fontSize: '0.8125rem', fontWeight: 400, '&:hover': { color: '#6B31C4' } }}>
                            Contact
                        </Link>
                        <Link href="/privacy-policy" target="_blank" rel="noopener noreferrer" sx={{ color: '#6B7280', textDecoration: 'none', fontSize: '0.8125rem', fontWeight: 400, '&:hover': { color: '#6B31C4' } }}>
                            Privacy
                        </Link>
                        <Link href="/terms-conditions" target="_blank" rel="noopener noreferrer" sx={{ color: '#6B7280', textDecoration: 'none', fontSize: '0.8125rem', fontWeight: 400, '&:hover': { color: '#6B31C4' } }}>
                            Terms
                        </Link>
                        <Link href="#" sx={{ color: '#6B7280', textDecoration: 'none', fontSize: '0.8125rem', fontWeight: 400, '&:hover': { color: '#6B31C4' } }}>
                            Help
                        </Link>
                    </Box>
                    <Typography sx={{ color: '#9CA3AF', fontSize: '0.75rem', fontWeight: 400 }}>
                        © {new Date().getFullYear()} <span style={{ color: '#6B31C4', fontWeight: 500 }}>RONO Jobs</span>
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default PageRoutes
